module.exports = __webpack_public_path__ + "img/pagoefectivo.fa5f7940.png";